import { __ } from "@wordpress/i18n";
import React, { useState } from 'react';
import ipReload from '../assets/images/ipReload.svg';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from "../contexts/MenuContext";
import countries from '../data/countries.json';
import withForm from '../pages/withForm';
import apiFetch from '@wordpress/api-fetch';

const RestrictionsSettings = ({handleChange}) => {

    const {
        settingData, 
    } = useMenu();
    const [options, setOptions] = useState(settingData?.restrictions?.settings)

    const [ipLoading, setIPLoading] = useState(false);
    const handleIPReset = () => {
        setIPLoading(true);
        const API_URL = "/ultimate-security/v1/get-ip";
    
        apiFetch({ path: API_URL, method: 'GET' })
            .then(response => {
                handleChange('restrictions.settings.your_website_ip_address', response?.ip);
                handleChange('restrictions.settings.your_current_location', response?.country);
                setIPLoading(false);
            })
            .catch(error => {
                console.error("Error fetching security settings:", error);
                setIPLoading(false);
            });
    };
    return (
        <>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Firewall On/Off", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Enable or disable the restrictions that you applied below to your site.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/disable restrictions", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Apply Restrictions", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "Set the conditions bellow", "ultimate-security" )}</p>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="restrictions.settings.firewall"
                                    checked={settingData?.restrictions?.settings?.firewall} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Text Input */}
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Your website IP address", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("See which IP you are currently browsing from.", "ultimate-security")}</p>
                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("This is your current ip", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{settingData?.restrictions?.settings?.['your_website_ip_address']}</div>
                                    <img className={ipLoading?'rotate':''} src={ipReload} alt="" onClick={handleIPReset} />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title="Note" content="You need to fetch for the first time." />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Your current location/country:", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("See which country you are currently browsing from.", "ultimate-security")}</p>
                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("This is your current location", "ultimate-security")}/>
                                    <div className="form-control-plaintext">{settingData?.restrictions?.settings?.['your_current_location']}</div>
                                    <img className={ipLoading?'rotate':''} src={ipReload} alt="" onClick={handleIPReset} />
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title="Note" content="You need to fetch for the first time." />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Blocked countries list:", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the list of countries you would like to block for your WooCommerce pages.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("List of blocked countries", "ultimate-security")}/>                                    
                                    <TagInput 

                                        name='restrictions.settings.blocked_countries_list' 
                                        type='country' 
                                        initialTags={settingData?.restrictions?.settings?.["blocked_countries_list"]} 
                                        handleChange={handleChange} 
                                        whitelist={countries}                                      
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Blacklisted IPs", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the list of IPs you would like to block for your WooCommerce pages.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("List of black listed ips", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='restrictions.settings.blacklisted_ips' 
                                        type='ip' 
                                        initialTags={settingData?.restrictions?.settings?.['blacklisted_ips']} 
                                        handleChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Allow only traffic from this country:", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the list of countries of countries you would like to allow for your WooCommerce pages.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("List of allowed countries", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='restrictions.settings.allow_only_traffic_from_this_country' 
                                        type='country' 
                                        initialTags={settingData?.restrictions?.settings?.["allow_only_traffic_from_this_country"]} 
                                        handleChange={handleChange}  
                                        whitelist={countries}                                         
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Whitelisted IPs", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the list of IPs you would like to allow for your WooCommerce pages.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("List of white listed ips", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='restrictions.settings.whitelisted_ips' 
                                        type='ip' 
                                        initialTags={settingData?.restrictions?.settings?.['whitelisted_ips']} 
                                        handleChange={handleChange} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Debug Log On/Off:", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Debug mode adds a top bar for easy switching for both frontend and backend.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Show/hide top debug bar", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Debug bar", "ultimate-security")}</h6>
                                </div>
                                <div className="content-below-with-hint">                                    
                                    <p className="pl-body text-text">{__( "Enable/disable debug bar", "ultimate-security" )}</p>
                                </div>
                            </div>
                            
                            <div className="col-auto">
                                <Switch 
                                    name="restrictions.settings.debug_log"
                                    checked={settingData?.restrictions?.settings?.['debug_log']} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(RestrictionsSettings, 'restrictions.settings');